module.exports = __webpack_public_path__ + "img/41.549d0025.jpeg";